import React from "react";
import { Grid, Grow, Stack, Typography, Zoom } from "@mui/material";
import { DeviceStatus } from "Infrastructure/Models/Messages/Dto/DeviceStatus";
import { HubConnection } from "@microsoft/signalr";
import { EmptyState } from "Shared/Icons/EmptyState";
import InstanceCard from "./InstanceCard";

type Props = {
	deviceStatuses: DeviceStatus[] | null;
	hubConnection: HubConnection | null;
};

const InstancesList: React.FunctionComponent<Props> = (props) => {
	if (!props.deviceStatuses || props.deviceStatuses.length === 0) {
		return (
			<Grow in={true}>
				<Stack justifyContent="center" alignItems="center">
					<EmptyState />
					<Typography variant="h2" color="primary">
						Žádné instance
					</Typography>
				</Stack>
			</Grow>
		);
	}

	return (
		<Grid container spacing={{ xs: 1, sm: 1, md: 2 }}>
			{props.deviceStatuses.map((item, _index) => {
				return (
					<Zoom
						key={`instance-card-${item.deviceName}`}
						in={true}
						style={{ transitionDelay: `${_index * 10}ms` }}
					>
						<Grid item sx={{ width: 304.5 }}>
							<InstanceCard
								deviceStatuses={props.deviceStatuses}
								deviceStatus={item}
								hubConnection={props.hubConnection}
							/>
						</Grid>
					</Zoom>
				);
			})}
		</Grid>
	);
};

export default React.memo(InstancesList);
